import {Component, computed, input, inject} from '@angular/core';
import {RotaDataService} from '../../../../services/store/rota-data.service';
import {Rota} from '../../../../classes/models/rota/Rota';
import {DayOfWeek} from '../../../../classes/enums/DayOfWeek';
import {EmployeePositionId} from '../../../../classes/models/employee/Employee';

/**
 * This component displays a holiday on a weekly rota page.
 */
@Component({
  selector: 'app-rota-week-holiday',
  templateUrl: './rota-week-holiday.component.html',
  styleUrls: ['./rota-week-holiday.component.less'],
})
export class RotaWeekHolidayComponent {
  private rotaDataService = inject(RotaDataService);


  /** The date of a rota. */
  dayOfWeek = input<DayOfWeek>();
  /** Identifiers of an employee and position. */
  employeePositionId = input<EmployeePositionId>();
  /** Rota data for a week. */
  rota = input<Rota>();

  /** A rota full day absence assignment of an employee. */
  absenceAssignment = computed(() => {
    return this.rota().fullDayAbsenceAssignments
            .find(assignment => assignment.hasEqualEmployeeAndDay(this.employeePositionId(), this.dayOfWeek()));
  });

  /** Checks if the day should be showed as holiday. */
  showAsHoliday = computed(() => this.absenceAssignment() !== undefined
          || this.rotaDataService.employeeOnHolidayAllWeek()?.get(this.employeePositionId()?.value))

}
